<p-dropdown appendTo="body" name="{{name}}" id="pdd_id_{{name}}" [options]="options" [(ngModel)]="value" [required]="required"
  [disabled]='disabled' (onFocus)='focused($event)' (onBlur)="blured($event)" styleClass="{{class}}" [style]="style" [panelStyle]="panelStyle"
  (onChange)=" valuechange($event)" [placeholder]="placeholder" [filter]="filter" [showClear]="showClear" [filterBy]="filterBy">
  <ng-template pTemplate="selectedItem" let-dataItem>
    <span class="template" *ngIf="dataItem && format=='currency'">${{dataItem["value"]}}</span>
    <span class="template" *ngIf="dataItem && format!=='currency' ">
      {{dataItem["value"] }}</span>
  </ng-template>
  <ng-template let-dataItem pTemplate="item">
    <span class="template" *ngIf="dataItem && format=='currency'">${{dataItem["value"]}}</span>
    <span class="template" *ngIf="dataItem && format!=='currency'">
      {{dataItem["value"]}}</span>
  </ng-template>
</p-dropdown>
